import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loading-state',
  templateUrl: './loading-state.component.html',
  styleUrls: ['./loading-state.component.scss'],
})
export class LoadingStateComponent {
  @Input() label = 'Carregando';
}
